const tab_sections = {
    overview: 'Vista geral',
    resources: 'Recursos',
    users: 'Utilizadores',
    access_control: 'Controlo de acesso',
    help_and_support: 'Ajuda e suporte',
    tenant: 'Arrendatário',
    automation: 'Automação',
};
export default Object.freeze(tab_sections);
